/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates what editor type to use for cell editing.
 */
export var EditorType = /*@__PURE__*/ (function (EditorType) {
    /**
     * Default edit type used in cell editing.
     */
    EditorType[EditorType["Default"] = 0] = "Default";
    /**
     * Use a text editor for cell editing.
     */
    EditorType[EditorType["Text"] = 1] = "Text";
    /**
     * Use a numeric editor for cell editing.
     */
    EditorType[EditorType["Numeric"] = 2] = "Numeric";
    /**
     * Use a date editor for cell editing.
     */
    EditorType[EditorType["Date"] = 3] = "Date";
    /**
     * Use a combo editor for cell editing.
     */
    EditorType[EditorType["Combo"] = 4] = "Combo";
    return EditorType;
})({});
/**
 * @hidden
 */
export var EditorType_$type = /*@__PURE__*/ markEnum('EditorType', 'Default,0|Text,1|Numeric,2|Date,3|Combo,4');
//# sourceMappingURL=EditorType.js.map
